import React, { useState } from "react";
import styles from "./priceCard.module.css";
import styles2 from "./PriceCardBF.module.css";
import Button from "../../componentsV2/atoms/Button/Button";
import SVGIcon from "../../componentsV2/atoms/SVGIcon";
import { PopupModal, useCalendlyEventListener } from "react-calendly";
import { FiArrowUpRight } from "react-icons/fi";
import useMixpanelHook from "../../utility/useMixpanelHook";

function CustomCard({ plansType, isDeal = false }) {
    const [modal, setModal] = useState(false);
    const { mixpanelTrack } = useMixpanelHook();
    useCalendlyEventListener({
        onEventScheduled: (e) => {
            mixpanelTrack("Enterprise - call scheduled");
        },
    });
    return (
        <div className={`${styles.priceCardWrapper}`}>
            <div
                className={`${styles.priceCard}  ${
                    isDeal && styles.priceCardBF
                }`}
            >
                <div className={styles.cardTopDiv}>
                    <div className={styles.categoryHeading}>Enterprise</div>
                    {isDeal ? (
                        <div
                            className={styles2.categoryInfo}
                            style={{ minHeight: isDeal ? "28px" : "auto" }}
                        >
                            Ideal for{" "}
                            <span className={styles2.boldTypes}>
                                Enterprise teams
                            </span>
                        </div>
                    ) : (
                        <div className={styles.categoryInfo}>
                            Ideal for Enterprise teams
                        </div>
                    )}
                </div>
                <div
                    className={`${
                        isDeal ? styles2.cardPricingDiv : styles.cardPricingDiv
                    }`}
                >
                    <div
                        className={`${
                            isDeal
                                ? styles2.cardPriceOriginaldiv
                                : styles.cardPriceOriginaldiv
                        }`}
                        style={{ marginTop: plansType == 1 ? "72px" : "72px" }}
                    >
                        <span className={styles.cardPriceOriginal}>Custom</span>

                        <div className={styles.youSave}>
                            Tailored for your needs
                        </div>
                    </div>
                </div>
                <Button
                    text={"Talk To Us"}
                    style={{
                        width: "100%",
                        borderRadius: "26px",
                        // background: isDeal ? "#6922e9" : `rgb(1, 77, 197)`,
                        background: `rgb(1, 77, 197)`,
                        minHeight: "50px",
                        color: isDeal ? "#fff" : `#fff`,
                    }}
                    height="50px"
                    width="100%"
                    handler={() => {
                        mixpanelTrack("Enterprise - Talk to us clicked");
                        setModal(true);
                    }}
                    Icon={() => <FiArrowUpRight />}
                />

                <ul className={styles.checksList}>
                    <h4 className={styles.includeText}>
                        {" "}
                        <br />
                    </h4>
                    <li>
                        {isDeal ? (
                            <div className={styles2.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/SingleTick.svg"
                                ></SVGIcon>
                            </div>
                        ) : (
                            <div className={styles.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/check.svg"
                                ></SVGIcon>
                            </div>
                        )}
                        Custom user seats
                    </li>
                    <li>
                        {isDeal ? (
                            <div className={styles2.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/SingleTick.svg"
                                ></SVGIcon>
                            </div>
                        ) : (
                            <div className={styles.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/check.svg"
                                ></SVGIcon>
                            </div>
                        )}
                        Custom usage
                    </li>
                    <li>
                        {isDeal ? (
                            <div className={styles2.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/SingleTick.svg"
                                ></SVGIcon>
                            </div>
                        ) : (
                            <div className={styles.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/check.svg"
                                ></SVGIcon>
                            </div>
                        )}
                        Unlimited Web pages (Custom)
                    </li>
                    <li>
                        {isDeal ? (
                            <div className={styles2.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/SingleTick.svg"
                                ></SVGIcon>
                            </div>
                        ) : (
                            <div className={styles.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/check.svg"
                                ></SVGIcon>
                            </div>
                        )}
                        Advanced AI models
                    </li>
                    <li>
                        {isDeal ? (
                            <div className={styles2.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/SingleTick.svg"
                                ></SVGIcon>
                            </div>
                        ) : (
                            <div className={styles.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/check.svg"
                                ></SVGIcon>
                            </div>
                        )}
                        Custom AI pipeline for SEO Content
                    </li>
                    <li>
                        {isDeal ? (
                            <div className={styles2.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/SingleTick.svg"
                                ></SVGIcon>
                            </div>
                        ) : (
                            <div className={styles.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/check.svg"
                                ></SVGIcon>
                            </div>
                        )}
                        Custom AI templates
                    </li>
                    <li>
                        {isDeal ? (
                            <div className={styles2.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/SingleTick.svg"
                                ></SVGIcon>
                            </div>
                        ) : (
                            <div className={styles.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/check.svg"
                                ></SVGIcon>
                            </div>
                        )}
                        Enterprise grade security
                    </li>
                    <li>
                        {isDeal ? (
                            <div className={styles2.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/SingleTick.svg"
                                ></SVGIcon>
                            </div>
                        ) : (
                            <div className={styles.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/check.svg"
                                ></SVGIcon>
                            </div>
                        )}
                        PO and invoicing
                    </li>
                    <li>
                        {isDeal ? (
                            <div className={styles2.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/SingleTick.svg"
                                ></SVGIcon>
                            </div>
                        ) : (
                            <div className={styles.check}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/check.svg"
                                ></SVGIcon>
                            </div>
                        )}
                        Tailored onboarding
                    </li>
                </ul>
            </div>
            <PopupModal
                open={modal}
                onModalClose={() => setModal(false)}
                url="https://calendly.com/d/5gx-7jm-fw2/scalenut-demo?utm_source=product&utm_medium=entp"
                rootElement={document.getElementById("root")}
            />
        </div>
    );
}

export default CustomCard;
